import {Component, OnDestroy, OnInit} from '@angular/core';
import {EffectiveDateService} from '@emm/common-items/services/effective-date.service';
import {Subject, takeUntil} from 'rxjs';

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss'],
    standalone: false
})
export class LayoutComponent implements OnInit, OnDestroy {
    effectiveDate: Date | null = null;
    minDate: Date;
    private destroy$ = new Subject<void>();

    constructor(private effectiveDateService: EffectiveDateService) {
        this.minDate = this.effectiveDateService.minDate;
    }

    ngOnInit() {
        this.effectiveDateService.effectiveDate$
            .pipe(takeUntil(this.destroy$))
            .subscribe(date => this.effectiveDate = date);
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    onDateChange(event: any) {
        const value: Date | null = event?.value ?? null;
        this.effectiveDateService.setEffectiveDate(value);
    }
}
